import React, { useState } from "react";

/**
 * NumericRating — 1..max chip-style rater. Clearer than a row of tiny stars for larger scales.
 *
 * Props:
 *   value      current rating (0 = none)
 *   onChange   (n) => void
 *   max        highest possible rating (default 10)
 *   readOnly   disables interaction
 *   testId     base data-testid; buttons get testId + "-chip-N"
 */
export default function NumericRating({
  value = 0,
  onChange,
  max = 10,
  readOnly = false,
  testId = "numeric-rating",
  compact = false,
}) {
  const [hover, setHover] = useState(0);
  const display = hover || value || 0;
  const sizeCls = compact ? "w-8 h-8 text-xs" : "w-9 h-9 text-sm";
  const gapCls = compact ? "gap-1" : "gap-1.5";

  return (
    <div className={`inline-flex items-center ${gapCls} flex-wrap`} data-testid={testId}>
      {Array.from({ length: max }, (_, i) => i + 1).map((n) => {
        const active = n <= display;
        const isSelected = value === n;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onChange && onChange(n)}
            className={`${sizeCls} rounded-full font-bold flex items-center justify-center transition-all ${
              readOnly ? "cursor-default" : "hover:scale-110"
            } ${
              active
                ? "bg-[#722f37] text-white shadow-[0_3px_10px_rgba(114,47,55,0.32)]"
                : "bg-white text-[#722f37] border border-[#d6cfc0] hover:border-[#722f37]"
            } ${isSelected ? "ring-2 ring-offset-1 ring-[#c39d2b]" : ""}`}
            aria-label={`${n} out of ${max}`}
            aria-pressed={isSelected}
            data-testid={`${testId}-chip-${n}`}
          >
            {n}
          </button>
        );
      })}
      {display > 0 && (
        <span
          className={`ml-2 text-sm font-semibold ${
            display >= 8 ? "text-[#c39d2b]" : readOnly ? "text-[#5c5c5c]" : "text-[#722f37]"
          }`}
          data-testid={`${testId}-value`}
        >
          {display}/{max}
          {display >= 8 && <span className="ml-1 text-xs">✨ Golden</span>}
        </span>
      )}
    </div>
  );
}
